<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div *ngIf="!isAssessors" class="flex gap-10">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <h3 class="bold header_title dark-blue">Modifier l'adresse e-mail</h3>
      </div>

      <div class="p-20 bg-pastel-blue radius-10">
        <p class="no-margin dark-blue bold">{{assessor.name}}</p>
        <p class="no-margin light-blue">{{assessor.email}}</p>
      </div>

      <div>
        <div class="mb-10">
          <label class="dark-blue bold" for="">Nouvel e-mail <span class="red">*</span></label>
          <input class="w-full text-md dark-blue pap-input" type="email" 
                 [(ngModel)]="newEmail" 
                 (ngModelChange)="onNewEmailChange()">
        </div>

        <div>
          <label class="dark-blue bold" for="">Confirmer l'e-mail <span class="red">*</span></label>
          <input class="w-full text-md dark-blue pap-input" type="email" 
                 [(ngModel)]="confirmEmail" 
                 (ngModelChange)="onConfirmEmailChange()">
        </div>
      </div>

      <div>
        <p class="grey text-xs flex gap-20">
          <img src="assets/warning.svg" alt="warning icon" width="20px">
          Attention, un lien de confirmation sera envoyé à votre nouvelle adresse.
          Le changement ne sera effectif qu'après validation.
        </p>
      </div>

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
        <v8te-active-button [buttonText]="'Annuler'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
          [border]="'solid 1px #D9D9D9'" [active]="true" (click)="onDismiss(true)" [height]="50" [minWidth]="190"
          [widthPercent]="100" [bold]="true"></v8te-active-button>

        <v8te-active-button [buttonText]="'Enregistrer'" [primaryColor]="'#1990FF'" [textPrimaryColor]="'#FFFFFF'"
          [active]="isFormValid" (click)="onDismiss(true)" [height]="50" [minWidth]="190"
          [widthPercent]="100" [bold]="true"></v8te-active-button>
      </div>
    </div>
  </div>
</div>